import styled from 'styled-components';
import { container, spacing } from '../../../theme';
import { Heading2 } from '../../shared/Typography';

export const StyledPositions = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  padding-bottom: ${spacing('xl4')};
  padding-top: ${spacing('xl5')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  ${Heading2} {
    margin-bottom: ${spacing('xl3')};
    text-align: center;
  }
`;

export const StyledPositionsGrid = styled.div`
  &.loading {
    opacity: 0.2;
    pointer-events: none;
  }
  .masonry-grid {
    display: flex;
    margin-left: -${spacing('xl')}; /* gutter size offset */
    width: auto;
  }
  .masonry-column {
    padding-left: ${spacing('xl')}; /* gutter size */
    background-clip: padding-box;

    &:empty {
      display: none;
    }

    > div {
      margin-bottom: ${spacing('xl')};
    }
  }
`;
